import { createHighSpenderList } from '@/modules/tracking/new-subscriber-analysis/service/create-high-spender-list.ts'
import { createLowSpenderList } from '@/modules/tracking/new-subscriber-analysis/service/create-low-spender-list.ts'
import { getSpendingListCustomer } from '@/modules/tracking/new-subscriber-analysis/service/get-spending-list-customer.ts'
import { getSubscribersAnalysis } from '@/modules/tracking/new-subscriber-analysis/service/get-subscribers-analysis.ts'

export const SubscriberAnalysisService = {
  getSpendingListCustomer,
  getSubscribersAnalysis,
  createHighSpenderList,
  createLowSpenderList,
}
